import {
  ContractingStatusColorEnum,
  CreditSimulationOriginEnum,
  OnlineContractingStateEnum,
} from 'v3/data/store/onlineContracting/enums';
import { FiltersType, IOnlineContractingState } from './types';

export const filtersInitialState: FiltersType = {
  search: '',
  origin: '',
  rowsPerPage: 20,
  page: 0,
  finalDate: undefined,
  startDate: undefined,
  status: undefined,
};

export const onlineContractingInitialState: IOnlineContractingState = {
  paymentDetails: {
    paymentId: '',
    orderId: '',
    origin: '' as CreditSimulationOriginEnum,
    totalValue: 0,
    paymentStatus: '',
    buyer: { fullName: '', cpf: '' },
    shippingValue: 0,
    items: [],
    address: {
      cityState: '',
    },
    device: {
      imei: '',
    },
    history: [],
  },
  list: {
    items: [],
    count: 0,
  },
  contractingKey: '',
  contractingState: OnlineContractingStateEnum.ContractingStarted,
  filter: filtersInitialState,
  statusColor: ContractingStatusColorEnum.undefined,
};
